import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, PhoneOff, VideoOff, FileText } from "lucide-react";
import { usePageSeo, JsonLd, SITE_URL } from "../components/common";

export default function TirageADistance() {
  usePageSeo({
    title: "Tirage de cartes à distance avec Noëmie",
    description: "Tirage de cartes à distance avec Noëmie, ta sorcière préférée : lecture intuitive des cartes, sans appel ni visio. Tu reçois ton compte rendu écrit.",
    path: "/tirage-de-cartes-a-distance",
  });
  return (
    <div className="home-dark min-h-[80vh]">
      <JsonLd data={{
        "@context": "https://schema.org", "@type": "Service",
        name: "Tirage de cartes intuitif à distance",
        serviceType: "Cartomancie intuitive à distance",
        provider: { "@id": `${SITE_URL}/#noemie` },
        areaServed: "FR",
        description: "Tirage de cartes intuitif réalisé à distance par Noëmie, sans appel ni visioconférence, avec compte rendu écrit.",
        url: `${SITE_URL}/tirage-de-cartes-a-distance`,
      }} />
      <div className="container-x py-12 sm:py-20 fade-up max-w-3xl">
        <div className="eyebrow mb-3 !text-[#DFC07B]">Tirages intuitifs</div>
        <h1 className="font-serif text-4xl sm:text-5xl font-medium text-[#F9F5EE]">Tirage de cartes à distance avec Noëmie</h1>
        <div className="gold-divider my-6 w-28" />
        <div className="space-y-5 text-[#E7DCEA] leading-relaxed text-lg">
          <p>Je réalise mes tirages de cartes <strong>entièrement à distance</strong>. Tu n'as pas besoin d'être disponible à un horaire précis, ni de te connecter à un appel ou une visioconférence.</p>
          <p>À l'heure réservée, je me pose avec ton prénom, ton nom, ta demande et mes cartes. Je lis ce qui se présente à travers mon intuition et mes ressentis, puis je t'envoie ton <strong>compte rendu écrit</strong> par WhatsApp ou par e-mail.</p>
          <p>Je ne te prédis pas ton avenir. Je t'aide à éclairer ton présent, comprendre ce qui se joue et écouter ce que ton intuition essaie de te dire.</p>
        </div>
        <div className="mt-8 flex flex-wrap gap-4 text-sm text-[#CBB9CF]">
          <span className="inline-flex items-center gap-2"><PhoneOff size={16} /> Aucun appel</span>
          <span className="inline-flex items-center gap-2"><VideoOff size={16} /> Aucune visio</span>
          <span className="inline-flex items-center gap-2"><FileText size={16} /> Compte rendu écrit</span>
        </div>
        <div className="mt-9 flex flex-wrap gap-3">
          <Link to="/guidances" className="btn-primary" data-testid="seo-cta-tirages">Découvrir mes tirages intuitifs <ArrowRight size={16} /></Link>
          <Link to="/cartomancie" className="btn-ghost-gold">Ma façon de lire les cartes</Link>
        </div>
      </div>
    </div>
  );
}
